import { useContext } from 'react';

import UserContext from './user.context';
import type { ContextValue } from './type';

export function useUser(): ContextValue {
  return useContext(UserContext);
}
